import MaterialNameStack from '#/modules/imsMgmt/receipts/shared/MaterialNameStack';
import {
  resolveLineMaterial,
  resolveLineMaterialNo,
} from '#/modules/imsMgmt/receipts/stocktake/helper/resolveLineMaterial';
import { formatDateTimeOrDash } from '#/utils/date';
import { formatDisplayQty } from '#/utils/formatNumber';

function displayOrDash(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

function resolveStockNo(line) {
  return line?.stockNo || line?.inventoryStock?.stockNo || '';
}

function resolveSystemQty(line) {
  return line?.systemQty ?? line?.baseQty;
}

function resolveCountedQty(line) {
  return line?.countedQty ?? line?.countedQuantity;
}

function resolveWarehouseLabel(warehouse) {
  if (!warehouse) {
    return '—';
  }
  return warehouse.name || warehouse.code || '—';
}

function resolveUnitLabel(unit) {
  if (!unit) {
    return '—';
  }
  return unit.name || unit.code || '—';
}

/** Detail 明細欄：依後端 lines[] 序；系統量取 systemQty（baseQty 舊別名），缺值顯示 —。 */
export function buildStocktakeDetailLineColumns() {
  return [
    {
      id: 'stockNo',
      header: '庫存編號',
      size: 140,
      enableSorting: false,
      cell: ({ row }) => displayOrDash(resolveStockNo(row.original)),
    },
    {
      id: 'mtr',
      header: '物料',
      size: 180,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => {
        const mtr = resolveLineMaterial(row.original);
        if (!mtr) {
          return '—';
        }
        return (
          <MaterialNameStack
            name={mtr.name}
            code={resolveLineMaterialNo(mtr)}
          />
        );
      },
    },
    {
      id: 'countedWarehouse',
      header: '盤點倉',
      size: 140,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => resolveWarehouseLabel(row.original.countedWarehouse),
    },
    {
      id: 'unit',
      header: '單位',
      size: 88,
      enableSorting: false,
      cell: ({ row }) => resolveUnitLabel(row.original.unit),
    },
    {
      id: 'systemQty',
      header: '系統量',
      size: 100,
      enableSorting: false,
      meta: { cellClassName: 'text-right' },
      cell: ({ row }) => formatDisplayQty(resolveSystemQty(row.original)),
    },
    {
      id: 'countedQty',
      header: '盤點數量',
      size: 100,
      enableSorting: false,
      meta: { cellClassName: 'text-right' },
      cell: ({ row }) => formatDisplayQty(resolveCountedQty(row.original)),
    },
    {
      id: 'countedAt',
      header: '盤點時間',
      size: 160,
      enableSorting: false,
      cell: ({ row }) => formatDateTimeOrDash(row.original.countedAt),
    },
  ];
}
